import { parseKoreanDateTime } from "lib/utils/koreanDateTime";

const KOREA_TIME_ZONE = "Asia/Seoul";

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: KOREA_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

const DATE_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: KOREA_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const YEAR_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: KOREA_TIME_ZONE,
  year: "numeric",
});

function getDateParts(date, formatter) {
  return formatter
    .formatToParts(date)
    .reduce((parts, part) => {
      if (part.type !== "literal") {
        parts[part.type] = part.value;
      }
      return parts;
    }, {});
}

function formatDateTime(date) {
  const parts = getDateParts(date, DATE_TIME_FORMATTER);
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
}

function formatDay(date) {
  const parts = getDateParts(date, DATE_FORMATTER);
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function dateformat(date) {
  const parsedDate = parseKoreanDateTime(date);

  if (!parsedDate) {
    return {
      hasTimeDate: "-",
      hasDayDate: "",
      year: "",
    };
  }

  return {
    hasTimeDate: formatDateTime(parsedDate),
    hasDayDate: formatDay(parsedDate),
    year: YEAR_FORMATTER.format(parsedDate),
  };
}
